/**
 * 操作命令的常量定义
 */

/**
 * 全局：操作命令
 */
// 全局加载基础数据:命局列表,强弱列表
export const GLOBAL_BASIC_INIT_DATA = 'GLOBAL_BASIC_INIT_DATA';

/**
 * 导入数据页面：操作命令
 */
// 提交导入数据
export const IMPORT_SUBMIT_IMPORT = 'IMPORT_SUBMIT_IMPORT';

/**
 * 起盘页面：操作命令
 */
// 地址选择器选择完成
export const COLLATE_CONFIRM_AREA = 'COLLATE_CONFIRM_AREA';
// 生日输入完成
export const COLLATE_CONFIRM_BIRTHDAY = 'COLLATE_CONFIRM_BIRTHDAY';
// 开始起盘
export const COLLATE_START_COLLATE = 'COLLATE_START_COLLATE';
// 四柱起盘:初始化八字数据
export const COLLATE_SIZHU_INIT_DATA = 'COLLATE_SIZHU_INIT_DATA';
// 四柱起盘:更新相同八字的数据列表
export const COLLATE_SIZHU_UPDATE_SAME_EIGHT_WORD = 'COLLATE_SIZHU_UPDATE_SAME_EIGHT_WORD';
// 四柱起盘:自动显示地支的选择弹框
export const COLLATE_SIZHU_AUTO_SHOW_CHOOSE_ITEM_POP = 'COLLATE_SIZHU_AUTO_SHOW_CHOOSE_ITEM_POP';
// 四柱起盘:更新选择框的数据
export const COLLATE_UPDATE_CHOOSE_ITEM_POP_DATA = 'COLLATE_UPDATE_CHOOSE_ITEM_POP_DATA';
// 四柱起盘:确定修改选择框的数据
export const COLLATE_CHOOSE_ITEM_POP_DATA = 'COLLATE_CHOOSE_ITEM_POP_DATA';
// 四柱起盘:开始起盘
export const COLLATE_START_SIZHU_COLLATE = 'COLLATE_START_SIZHU_COLLATE';
// 重置起盘数据
export const COLLATE_RESET_DATA = 'COLLATE_RESET_DATA';
// 初始化起盘表单数据
export const COLLATE_INIT_FORM_DATA = 'COLLATE_INIT_FORM_DATA';

/**
 * 起卦页面：操作命令
 */
// 确认起卦时间
export const DIAGRAM_CONFIRM_TIME = 'DIAGRAM_CONFIRM_TIME';
// 更新铜钱起卦信息
export const DIAGRAM_UPDATE_CHOOSED_COPER = 'DIAGRAM_UPDATE_CHOOSED_COPER';
// 编译卦的type_data信息
export const DIAGRAM_COMPILE_DIAGRAM_TYPE_DATA = 'DIAGRAM_COMPILE_DIAGRAM_TYPE_DATA';
// 反编译卦的type_data信息
export const DIAGRAM_DECOMPILE_DIAGRAM_TYPE_DATA = 'DIAGRAM_DECOMPILE_DIAGRAM_TYPE_DATA';
// 更新卦编辑表单
export const DIAGRAM_UPDATE_EDIT_FORM = 'DIAGRAM_UPDATE_EDIT_FORM';
// 更新卦信息和卦的列表
export const DIAGRAM_UPDATE_DIAGRAM_DETAIL_AND_LIST = 'DIAGRAM_UPDATE_DIAGRAM_DETAIL_AND_LIST';
// 更新卦的列表
export const DIAGRAM_UPDATE_DIAGRAM_LIST = 'DIAGRAM_UPDATE_DIAGRAM_LIST';

/**
 * 分组页面：操作命令
 */
// 初始化分组列表数据
export const GROUP_INIT_LIST = 'GROUP_INIT_LIST';
// 初始化分组列表数据:from基础数据
export const GROUP_INIT_GROUP_LIST = 'GROUP_INIT_GROUP_LIST';
// 初始化分组列表数据
export const GROUP_INIT_GROUP_DATA = 'GROUP_INIT_GROUP_DATA';
// 重置选择分组的数据
export const GROUP_RESET_CHOOSE_GROUP_DATA = 'GROUP_RESET_CHOOSE_GROUP_DATA';
// UI数据:操作选择的分组数据:添加数据
export const GROUP_ADD_SELECTED_GROUP_LIST = 'GROUP_ADD_SELECTED_GROUP_LIST';
// UI数据:操作选择的分组数据:删除数据
export const GROUP_REMOVE_SELECTED_GROUP_LIST = 'GROUP_REMOVE_SELECTED_GROUP_LIST';
// 显示or隐藏修改分组弹框
export const GROUP_TOGGLE_GROUP_CHANGE = 'GROUP_TOGGLE_GROUP_CHANGE';
// 增加分组
export const GROUP_ADD_GROUP = 'GROUP_ADD_GROUP';
// 修改分组
export const GROUP_UPDATE_GROUP = 'GROUP_UPDATE_GROUP';
// 删除分组
export const GROUP_DELETE_GROUP = 'GROUP_DELETE_GROUP';
// 批量修改起盘分组
export const GROUP_CHANGE_GROUP = 'GROUP_CHANGE_GROUP';
// 分组管理:批量删除起盘数据
export const GROUP_DELETE_GROUP_DATA = 'GROUP_DELETE_GROUP_DATA';
// 分组管理:更新列表数据:修改命盘数据后响应
export const GROUP_UPDATE_GROUP_DATA = 'GROUP_UPDATE_GROUP_DATA';
// 分组管理:重置列表数据
export const GROUP_RESET_SELECTED_GROUP_DATA = 'GROUP_RESET_SELECTED_GROUP_DATA';
// 分组管理:更新最近分组
export const GROUP_UPDATE_RECENT_GROUP_LIST = 'GROUP_UPDATE_RECENT_GROUP_LIST';

/**
 * 记录列表页面：操作命令
 */
// 初始化数据
export const RECORD_INIT_LIST = 'RECORD_INIT_LIST';
// 初始化最近浏览数据
export const RECORD_INIT_RECENTLY_LIST = 'RECORD_INIT_RECENTLY_LIST';
// 删除一条数据
export const RECORD_DELETE_DATA = 'RECORD_DELETE_DATA';
// 删除数据之后更新数据列表
export const RECORD_DELETE_DATA_LIST_DATA = 'RECORD_DELETE_DATA_LIST_DATA';
// 全部记录页:过滤列表数据操作-创建时间、最近浏览
export const RECORD_OTHER_FILTER_DATA = 'RECORD_OTHER_FILTER_DATA';
// 全部记录页:过滤列表数据更新
export const RECORD_UPDATE_FILTER_LIST_DATA = 'RECORD_UPDATE_FILTER_LIST_DATA';
// 全部记录页:更新列表数据(增加or修改排盘数据触发)
export const RECORD_UPDATE_RECORD_LIST_DATA = 'RECORD_UPDATE_RECORD_LIST_DATA';
// 全部记录页:更新列表数据的分组名(修改分组名触发)
export const RECORD_UPDATE_GROUP_NAME = 'RECORD_UPDATE_GROUP_NAME';
// 全部记录页:更新列表数据的分组(分组管理:移动到别的分组触发)
export const RECORD_UPDATE_GROUP_DATA = 'RECORD_UPDATE_GROUP_DATA';
// 全部记录页:更新列表数据的批盘状态
export const RECORD_UPDATE_DATA_PIPAN_STATUS = 'RECORD_UPDATE_DATA_PIPAN_STATUS';
// 全部记录页:更新列表数据的论盘状态
export const RECORD_UPDATE_DATA_LUNPAN_STATUS = 'RECORD_UPDATE_DATA_LUNPAN_STATUS';
// 全部记录页:更新列表数据的命局类型
export const RECORD_UPDATE_DATA_SITUATION = 'RECORD_UPDATE_DATA_SITUATION';
// 全部记录页:更新列表数据的强弱类型
export const RECORD_UPDATE_DATA_STRONG = 'RECORD_UPDATE_DATA_STRONG';


/**
 * 八字详情列表页面：操作命令
 */
// 初始化八字数据
export const DETAIL_INIT_DATA = 'DETAIL_INIT_DATA';
// 初始化本地的八字数据
export const DETAIL_INIT_LOCAL_DATA = 'DETAIL_INIT_LOCAL_DATA';
// 八字命盘详细:显示神煞
export const DETAIL_INIT_DETAIL_SHEN_SHA = 'DETAIL_INIT_DETAIL_SHEN_SHA';
// 八字命盘详细:显示合化冲
export const DETAIL_INIT_DETAIL_HE_HUA_CHONG = 'DETAIL_INIT_DETAIL_HE_HUA_CHONG';
// 八字命盘:刷新二维码url数据
export const DETAIL_UPDATE_QR_CODE_VALUE = 'DETAIL_UPDATE_QR_CODE_VALUE';
// 八字命盘:刷新命局类型
export const DETAIL_UPDATE_SITUATION_STRING = 'DETAIL_UPDATE_SITUATION_STRING';
// 八字命盘:刷新强弱类型
export const DETAIL_UPDATE_STRONG_STRING = 'DETAIL_UPDATE_STRONG_STRING';
// 重置八字命盘数据
export const DETAIL_RESET_DATA = 'DETAIL_RESET_DATA';

/**
 * 分享页面逻辑：操作命令
 */
// 显示分享的八字数据
export const DETAIL_SHARED_SHOW = 'DETAIL_SHARED_SHOW';
// 分享页面:手动保存流程
export const DETAIL_SHARED_UPDATE_SAVE = 'DETAIL_SHARED_UPDATE_SAVE';
// 分享页面:确定修改八字名称or分组
export const DETAIL_SHARED_CHANGE_NAME_GROUP = 'DETAIL_SHARED_CHANGE_NAME_GROUP';
// 分享页面:重置数据
export const DETAIL_SHARED_RESET_DATA = 'DETAIL_SHARED_RESET_DATA';
// 分享页面:保存弹框
export const DETAIL_SHARED_INIT_SAVE_POP = 'DETAIL_SHARED_INIT_SAVE_POP';
// 分享页面:更新保存弹框
export const DETAIL_SHARED_UPDATE_SAVE_POP = 'DETAIL_SHARED_UPDATE_SAVE_POP';
// 分享页面:列表弹框
export const DETAIL_SHARED_INIT_SELECT_POP = 'DETAIL_SHARED_INIT_SELECT_POP';

/**
 * 其他分享页面逻辑：操作命令
 */
// 其他分享页面:初始化列表弹框
export const OTHER_SHARED_INIT_SELECTE_POP = 'OTHER_SHARED_INIT_SELECTE_POP';
// 其他分享页面:初始化修改分组名称弹框
export const OTHER_SHARED_INIT_CHANGE_POP = 'OTHER_SHARED_INIT_CHANGE_POP';
// 其他分享页面:初始化保存弹框
export const OTHER_SHARED_INIT_SAVE_POP = 'OTHER_SHARED_INIT_SAVE_POP';
// 其他分享页面:重置数据
export const OTHER_SHARED_RESET_DATA = 'OTHER_SHARED_RESET_DATA';
// 其他分享页面:论盘分享:初始化保存弹框
export const OTHER_SHARED_DISCUSS_INIT_SAVE_POP = 'OTHER_SHARED_DISCUSS_INIT_SAVE_POP';
// 其他分享页面:论盘分享:初始化修改分组名称弹框
export const OTHER_SHARED_DISCUSS_INIT_CHANGE_POP = 'OTHER_SHARED_DISCUSS_INIT_CHANGE_POP';

/**
 * 基础数据：操作命令
 */
// 初始化命局数据
export const BASE_INIT_SITUATION_DATA = 'BASE_INIT_SITUATION_DATA';
// 增加命局数据
export const BASE_ADD_SITUATION = 'BASE_ADD_SITUATION';
// 修改命局数据
export const BASE_UPDATE_SITUATION = 'BASE_UPDATE_SITUATION';
// 删除命局数据
export const BASE_DELETE_SITUATION = 'BASE_DELETE_SITUATION';
// 初始化强弱数据
export const BASE_INIT_STRONG_DATA = 'BASE_INIT_STRONG_DATA';
// 增加强弱数据
export const BASE_ADD_STRONG = 'BASE_ADD_STRONG';
// 修改强弱数据
export const BASE_UPDATE_STRONG = 'BASE_UPDATE_STRONG';
// 删除强弱数据
export const BASE_DELETE_STRONG = 'BASE_DELETE_STRONG';
// 初始化药数据
export const BASE_INIT_MEDICINE_DATA = 'BASE_INIT_MEDICINE_DATA';
// 增加药数据
export const BASE_ADD_MEDICINE = 'BASE_ADD_MEDICINE';
// 修改药数据
export const BASE_UPDATE_MEDICINE = 'BASE_UPDATE_MEDICINE';
// 删除药数据
export const BASE_DELETE_MEDICINE = 'BASE_DELETE_MEDICINE';
// 初始化类型数据
export const BASE_INIT_TYPE_DATA = 'BASE_INIT_TYPE_DATA';

/**
 * 批盘页面逻辑：操作命令
 */
// 初始化批盘数据
export const COMMENT_INIT_DATA = 'COMMENT_INIT_DATA';
// 初始化批盘数据:App引入的部分做兼容处理
export const COMMENT_INIT_EMBEDDED_DATA = 'COMMENT_INIT_EMBEDDED_DATA';
// 初始化批盘数据:分享来的批盘
export const COMMENT_INIT_SHARE_DATA = 'COMMENT_INIT_SHARE_DATA';
// 初始化批盘数据:他人批盘
export const COMMENT_INIT_OTHER_DATA = 'COMMENT_INIT_OTHER_DATA';
// 更新批盘底部弹框数据
export const COMMENT_UPDATE_CHANGE_LIST = 'COMMENT_UPDATE_CHANGE_LIST';
// 更新大运流年列表的折叠响应
export const COMMENT_UPDATE_ACTIVE_NAMES = 'COMMENT_UPDATE_ACTIVE_NAMES';
// 提交更新批盘数据到服务器:base,situation,strong,other,suggest字段
export const COMMENT_SUBMIT_UPDATE_PIPAN = 'COMMENT_SUBMIT_UPDATE_PIPAN';
// 提交更新批盘数据到服务器:更新用药数据
export const COMMENT_SUBMIT_UPDATE_PIPAN_MEDICINE = 'COMMENT_SUBMIT_UPDATE_PIPAN_MEDICINE';
// 提交更新批盘数据到服务器:新增用药数据
export const COMMENT_SUBMIT_ADD_PIPAN_MEDICINE = 'COMMENT_SUBMIT_ADD_PIPAN_MEDICINE';
// 提交更新批盘数据到服务器:删除用药数据
export const COMMENT_SUBMIT_DELETE_PIPAN_MEDICINE = 'COMMENT_SUBMIT_DELETE_PIPAN_MEDICINE';
// 提交更新批盘数据到服务器:更新大运流年数据
export const COMMENT_SUBMIT_UPDATE_PIPAN_BIG = 'COMMENT_SUBMIT_UPDATE_PIPAN_BIG';
// 重置批盘数据
export const COMMENT_RESET_DATA = 'COMMENT_RESET_DATA';

/**
 * 他人批盘列表页面逻辑：操作命令
 */
// 更新列表数据:修改标题后
export const COMMENT_OTHER_UPDATE_LIST_DATA_TITLE = 'COMMENT_OTHER_UPDATE_LIST_DATA_TITLE';
// 更新列表数据:删除数据后
export const COMMENT_OTHER_DELETE_LIST_DATA = 'COMMENT_OTHER_DELETE_LIST_DATA';

/**
 * 论盘页面逻辑：操作命令
 */
// 发送图片:调取微信JSSDK接口
export const DISCUSS_CHAT_SEND_IMAGE = 'DISCUSS_CHAT_SEND_IMAGE';
// 接收到ws的消息
export const DISCUSS_CHAT_GET_WS_MESSAGE = 'DISCUSS_CHAT_GET_WS_MESSAGE';
// 发送我自己的ws消息:追加数据到列表与ws同时进行
export const DISCUSS_CHAT_SEND_MY_WS_MESSAGE = 'DISCUSS_CHAT_SEND_MY_WS_MESSAGE';

/**
 * 八字编辑页面：操作命令
 */
// 初始化编辑八字页面的数据
export const EDIT_DETAIL_INIT_DATA = 'EDIT_DETAIL_INIT_DATA';
// 八字编辑页面:动态更新UI显示数据
export const EDIT_DETAIL_UPDATE_DATA = 'EDIT_DETAIL_UPDATE_DATA';
// 八字编辑页面:保存修改的数据并提交后台
export const EDIT_DETAIL_SAVE_DATA = 'EDIT_DETAIL_SAVE_DATA';
// 八字编辑页面:重置编辑数据
export const EDIT_DETAIL_RESET_DATA = 'EDIT_DETAIL_RESET_DATA';


/**
 * 搜索页面：操作命令
 */
// 更新高级搜索选择框的数据
export const SEARCH_UPDATE_CHOOSE_ITEM_POP_DATA = 'SEARCH_UPDATE_CHOOSE_ITEM_POP_DATA';
// 确定选择高级搜索框的数据
export const SEARCH_CHOOSE_CHOOSE_ITEM_DATA = 'SEARCH_CHOOSE_CHOOSE_ITEM_DATA';
// 搜索框搜索确认搜索
export const SEARCH_CONFIRM_INPUT_SEARCH = 'SEARCH_CONFIRM_INPUT_SEARCH';
// 搜索页:删除数据后更新搜索结果列表
export const SEARCH_DELETE_RESULT_LIST_DATA = 'SEARCH_DELETE_RESULT_LIST_DATA';
// 八字编辑页面:重置编辑数据
export const SEARCH_RESET_DATA = 'SEARCH_RESET_DATA';


/**
 * 组件：操作命令
 */
// 初始化命盘运盘组件:排盘页数据
export const PLUGIN_INIT_DETAIL_FATE_FORTUNE_DATA = 'PLUGIN_INIT_DETAIL_FATE_FORTUNE_DATA';
// 改变八字命盘:增加右侧的数据
export const PLUGIN_INIT_DETAIL_FATE_SIDE_ADD = 'PLUGIN_INIT_DETAIL_FATE_SIDE_ADD';
// 改变八字命盘:删除右侧的数据
export const PLUGIN_INIT_DETAIL_FATE_SIDE_DELETE = 'PLUGIN_INIT_DETAIL_FATE_SIDE_DELETE';
// 八字运盘:切换格式的时候要检查数据
export const PLUGIN_CHECK_DETAIL_FORTUNE_DATA = 'PLUGIN_CHECK_DETAIL_FORTUNE_DATA';
// 显示流年数据
export const PLUGIN_INIT_DETAIL_SHOW_LIUNIAN = 'PLUGIN_INIT_DETAIL_SHOW_LIUNIAN';
// 显示流月数据
export const PLUGIN_INIT_DETAIL_SHOW_LIUYUE = 'PLUGIN_INIT_DETAIL_SHOW_LIUYUE';
// 显示流日数据
export const PLUGIN_INIT_DETAIL_SHOW_LIURI = 'PLUGIN_INIT_DETAIL_SHOW_LIURI';
// 显示流时数据
export const PLUGIN_INIT_DETAIL_SHOW_LIUSHI = 'PLUGIN_INIT_DETAIL_SHOW_LIUSHI';
// 重置命盘运盘数据
export const PLUGIN_INIT_RESET_DETAIL_FATE_FORTUNE_DATA = 'PLUGIN_INIT_RESET_DETAIL_FATE_FORTUNE_DATA';
// 初始化命盘运盘组件:迷你版的数据管理
export const PLUGIN_INIT_COMMENT_MINI_FATE_FORTUNE_DATA = 'PLUGIN_INIT_COMMENT_MINI_FATE_FORTUNE_DATA';
// 改变八字命盘:增加右侧的数据
export const PLUGIN_INIT_MINI_FATE_SIDE_ADD = 'PLUGIN_INIT_MINI_FATE_SIDE_ADD';
// 改变八字命盘:删除右侧的数据
export const PLUGIN_INIT_MINI_FATE_SIDE_DELETE = 'PLUGIN_INIT_MINI_FATE_SIDE_DELETE';
// 显示流年数据
export const PLUGIN_INIT_MINI_SHOW_LIUNIAN = 'PLUGIN_INIT_MINI_SHOW_LIUNIAN';
// 显示流月数据
export const PLUGIN_INIT_MINI_SHOW_LIUYUE = 'PLUGIN_INIT_MINI_SHOW_LIUYUE';
// 显示流日数据
export const PLUGIN_INIT_MINI_SHOW_LIURI = 'PLUGIN_INIT_MINI_SHOW_LIURI';
// 显示流时数据
export const PLUGIN_INIT_MINI_SHOW_LIUSHI = 'PLUGIN_INIT_MINI_SHOW_LIUSHI';
// 迷你盘:箭头切换数据显示行数
export const PLUGIN_INIT_TOGGLE_ARROW_CHANGE_SHOW_LINES = 'PLUGIN_INIT_TOGGLE_ARROW_CHANGE_SHOW_LINES';
// 迷你盘:联动触发运盘列表的点击事件:切换到某年某月
export const PLUGIN_INIT_COMMENT_TRIGGER_FORTUNE_ITEM_CLICK = 'PLUGIN_INIT_COMMENT_TRIGGER_FORTUNE_ITEM_CLICK';
// 重置命盘运盘数据
export const PLUGIN_INIT_RESET_MINI_FATE_FORTUNE_DATA = 'PLUGIN_INIT_RESET_MINI_FATE_FORTUNE_DATA';


// 更新引导页数据
export const REMINDER_UPDATE_STATUS_DATA = 'REMINDER_UPDATE_STATUS_DATA';


// 百科模块
// 百科：更新热门百科列表数据
export const FAMOUS_PEDIA_UPDATE_HOT_LIST_DATA = 'FAMOUS_PEDIA_UPDATE_HOT_LIST_DATA';
// 百科：更新最新创建百科列表数据
export const FAMOUS_PEDIA_UPDATE_NEW_LIST_DATA = 'FAMOUS_PEDIA_UPDATE_NEW_LIST_DATA';
// 百科：更新我的收藏百科列表数据
export const FAMOUS_PEDIA_UPDATE_COLLECT_LIST_DATA = 'FAMOUS_PEDIA_UPDATE_COLLECT_LIST_DATA';
// 百科：更新我的百科列表数据
export const FAMOUS_PEDIA_UPDATE_MY_LIST_DATA = 'FAMOUS_PEDIA_UPDATE_MY_LIST_DATA';
// 百科：更新最近浏览百科列表数据
export const FAMOUS_PEDIA_UPDATE_GLANCE_LIST_DATA = 'FAMOUS_PEDIA_UPDATE_GLANCE_LIST_DATA';
// 百科：更新顶部标题部分的按钮文本
export const FAMOUS_PEDIA_UPDATE_EDIT_TEXT = 'FAMOUS_PEDIA_UPDATE_EDIT_TEXT';

// 对比模块
// 对比：时间联动的时候更新数据
export const CONTRAST_UPDATE_TIME_INTERACTIVE_LIST = 'CONTRAST_UPDATE_TIME_INTERACTIVE_LIST';
// 对比：时间联动的时候删除数据时更新
export const CONTRAST_UPDATE_TIME_INTERACTIVE_DELETE_LIST = 'CONTRAST_UPDATE_TIME_INTERACTIVE_DELETE_LIST';


// 测算模块
// 测算：更新天赋性格相关数据-gift
export const REPORT_UPDATE_REPORT_GIFT_DATA = 'REPORT_UPDATE_REPORT_GIFT_DATA';
// 测算：更新天赋性格相关数据-diff
export const REPORT_UPDATE_REPORT_DIFF_DATA = 'REPORT_UPDATE_REPORT_DIFF_DATA';
// 测算：更新天赋性格相关数据-vip_year+vip_full
export const REPORT_UPDATE_REPORT_VIP_YEAR_FULL_DATA = 'REPORT_UPDATE_REPORT_VIP_YEAR_FULL_DATA';
// 测算：更新天赋性格相关数据-vip_full
export const REPORT_UPDATE_REPORT_VIP_FULL_DATA = 'REPORT_UPDATE_REPORT_VIP_FULL_DATA';


// 活动模块
// 活动：618终身VIP活动：跑活动倒计时
export const ACTIVITY_618_VIP_COUNT_DOWM_TIME = 'ACTIVITY_618_VIP_COUNT_DOWM_TIME';
// 活动：618终身VIP活动：跑活动倒计时2
export const ACTIVITY_618_VIP_COUNT_DOWM_NUMBER = 'ACTIVITY_618_VIP_COUNT_DOWM_NUMBER';
// 活动：618终身VIP活动：跑活动倒计时
export const ACTIVITY_648_VIP_COUNT_DOWM_TIME = 'ACTIVITY_648_VIP_COUNT_DOWM_TIME';


// 课程中心模块
// 课程：初始化列表数据
export const COURSE_INIT_LIST = 'COURSE_INIT_LIST';
// 课程：初始化学习记录列表数据
export const COURSE_INIT_RECORD_LIST = 'COURSE_INIT_RECORD_LIST';


